import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "../lib/cn.js";
const DOT = {
    neutral: "bg-muted-foreground/60",
    primary: "bg-primary",
    success: "bg-success",
    warning: "bg-warning",
    danger: "bg-destructive",
    info: "bg-info",
    outline: "bg-border",
};
/** What happened to a record, newest last: a dot and line per entry, the moment on the right. */
export function Timeline({ className, ...props }) {
    return _jsx("ol", { className: cn("flex flex-col", className), ...props });
}
export function TimelineItem({ title, when, tone = "neutral", children, className, }) {
    return (_jsxs("li", { className: cn("relative flex gap-3 pb-5 last:pb-0", className), children: [_jsx("span", { className: "absolute top-5 bottom-0 left-[5px] w-px bg-border [li:last-child>&]:hidden", "aria-hidden": true }), _jsx("span", { className: cn("mt-1.5 size-[11px] shrink-0 rounded-full ring-4 ring-card", DOT[tone]), "aria-hidden": true }), _jsxs("div", { className: "flex min-w-0 flex-1 flex-col gap-0.5 sm:flex-row sm:items-baseline sm:justify-between sm:gap-4", children: [_jsxs("div", { className: "flex min-w-0 flex-col gap-0.5", children: [_jsx("span", { className: "text-sm font-medium", children: title }), children === undefined ? null : _jsx("span", { className: "text-sm text-muted-foreground", children: children })] }), when === undefined ? null : (_jsx("span", { className: "shrink-0 text-xs whitespace-nowrap text-muted-foreground tabular-nums", children: when }))] })] }));
}
//# sourceMappingURL=timeline.js.map